/* eslint-disable react/require-default-props */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, FormLabel } from '@chakra-ui/core';
import { MultiOption, MultiSelect } from '../../administration/positionManagement/recruiterWatchAndFollow/positions/MultiSelect';
import { CandidateStatus } from '../CandidateSearchTypes';

interface StatusFilterProps {
  values: string[];
  onChange: (status: string[], isAllSelcted: boolean) => void;
  isSelectAll?: boolean;
  isDisabled?: boolean;
}

export const StatusFilter = React.memo(function StatusFilter({ values, onChange, isSelectAll, isDisabled }: StatusFilterProps) {
  const { t } = useTranslation('candidateSearch');

  const options: MultiOption<string>[] = Object.values(CandidateStatus).map((status) => ({
    value: status,
    label: t(`candidateStatus.${status}`),
  }));

  return (
    <FormControl display="flex" flexDirection="column" isDisabled={isDisabled}>
      <FormLabel htmlFor="label" mb="0" fontSize="sm">
        {t('filters.status.label')}
      </FormLabel>
      <MultiSelect
        options={options}
        selectedValues={values ?? /* istanbul ignore next */ []}
        onChange={onChange}
        selectAll={isSelectAll ?? false}
        label={t('filters.status.label')}
        allSelectText={t('filters.status.allSelected')}
        placeholder={t('filters.status.searchPlaceholder')}
        isLoading={false}
        disabled={isDisabled}
        height={400}
        itemHeight={30}
      />
    </FormControl>
  );
});
